import * as Configuration from '../../../app.constants.js';

export class QuickRepliesService {
  constructor($http, $q, MetricsFactory, $translate) {
    this._$http = $http;
    this._$q = $q;
    this.MetricsFactory = MetricsFactory;
    this.$translate = $translate;
  }

  copyScenario(companyId, sourceSiteId, destinationSiteId, scenarioId, scenarioName, scenarioFlavor) {
    let data = {
      destination_site_id: destinationSiteId,
      scenario_name: scenarioName
    }
    return this._$http.post(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + sourceSiteId +
      '/scenarios/' + scenarioId + '/copies' + '?flavor=' + scenarioFlavor,
      data);
  }

  copyBox(companyId, siteId, scenarioId, boxId, serializedGraph) {
    return this._$http.post(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId +
      '/scenarios/' + scenarioId + '/copies/box/' + boxId, serializedGraph);
  }

  getScenarios(companyId, scenarioFlavor) {
    return this._$http.get(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/scenarios/' + '?flavor=' + scenarioFlavor);
  }

  getScenario(companyId, siteId, scenarioId, scenarioFlavor) {
    return this._$http.get(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId +
      '/scenarios/' + scenarioId + '?flavor=' + scenarioFlavor);
  }

  createScenario(companyId, siteId, scenario, scenarioFlavor) {
    return this._$http.post(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId +
      '/scenarios' + '?flavor=' + scenarioFlavor, scenario);
  }

  deleteScenario(companyId, siteId, scenarioId, scenarioFlavor) {
    return this._$http.delete(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId +
      '/scenarios/' + scenarioId + '?flavor=' + scenarioFlavor);
  }


  updateScenario(companyId, siteId, scenario, scenarioFlavor) {
    return this._$http.put(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId +
      '/scenarios/' + scenario.common.id + '?flavor=' + scenarioFlavor, scenario);
  }

  createUniqueId(companyId, siteId, scenarioId) {
    return this._$http.post(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId +
      '/scenarios/' + scenarioId +
      '/unique-id/');
  }

  createUniqueIds(companyId, siteId, scenarioId, number_of_ids) {
    return this._$http.post(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId +
      '/scenarios/' + scenarioId +
      '/unique-id/?number_of_ids=' + number_of_ids);
  }

  getPostbackPayload(companyId, siteId, scenarioId, cell_id) {
    return this._$http.get(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId +
      '/scenarios/' + scenarioId +
      '/postback-payload/' + cell_id);
  }

  getSubBotClasses(companyId, siteId) {
    return this._$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/subbot/classes');
  }

  getSubBotExternalDescription(companyId, siteId, descriptionURL) {
    const data = {
      url: descriptionURL
    };
    return this._$http.post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/subbot/url', data);
  }

  forwardExternalSubbotDescription(companyId, siteId, description, descriptionURL, applicationId) {
    const data = {
      description: description,
      application_id: applicationId,
      url: descriptionURL
    };
    return this._$http.post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/subbot/external-description/', data);
  }

  getScenarioClicks(companyId, siteId, scenarioId, fromDate, toDate) {
    const from = this.MetricsFactory.formatFromDateForDayRangeQuery(fromDate);
    const to = this.MetricsFactory.formatToDateForDayRangeQuery(toDate);
    return this._$http.get(Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/scenarios/' + scenarioId + '/metrics'
      + '?from=' + from + '&to=' + to);
  }

  getAgentShortcutDependencies(companyId, siteId, scenarioId) {
    return this._$http.get(`${Configuration.constants.baseUrl}api/1.0/companies/${companyId}/sites/${siteId}/scenarios/${scenarioId}/agent-shortcuts-dependencies`);
  }

  createBoxClicksExports(companyId, siteId, scenarioId, metricData) {
    return this._$http.post(Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/scenarios/' + scenarioId + '/box-clicks-exports',
      {
        metric_data: metricData
      });
  }

  exportScenario(companyId, siteId, scenarioId) {
    return this._$http.post(Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/scenarios/' + scenarioId + '/template-export',
      {});
  }

  getInMessageCustomization(companyId, siteId) {
    return this._$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId + '/email-customization-for-email-notification-box');
  }

  cleanupButtonPayload(button) {
    if (button.type === 'postback') {
      delete button.url;
    }
    if (button.type === 'login') {
      delete button.title;
    }
    if (button.type === 'web_url') {
      if (!button.messenger_extensions) {
        delete button.fallback_url;
      }
    } else {
      delete button.webview_height_ratio;
      delete button.hide_webview_share_button;
      delete button.messenger_extensions;
      delete button.fallback_url;
    }
  }

  // Build the user emails that created or modified each scenario and the respective dates
  buildUserEmailsAndDates(scenariosOrSurveys, isSurvey = false) {
    scenariosOrSurveys.forEach(scenarioOrSurvey => {
      // Different object structure in case of survey
      let scenario;
      if (isSurvey) {
        // If the survey scenario is null then return these default values
        if (!scenarioOrSurvey.scenario) {
          scenarioOrSurvey.createdByEmail = this.$translate.instant('admin/users/is_admin');
          scenarioOrSurvey.lastModifiedByEmail = this.$translate.instant('admin/users/is_admin');
          scenarioOrSurvey.createdOn = this.$translate.instant('parameters/scenarios/not_applicable');
          scenarioOrSurvey.lastModifiedOn = this.$translate.instant('parameters/scenarios/not_applicable');
          return;
        } else {
          scenario = scenarioOrSurvey.scenario.common;
        }
      } else {
        scenario = scenarioOrSurvey;
      }

      scenarioOrSurvey.createdByEmail = scenario.created_by_email ? scenario.created_by_email
        : this.$translate.instant('admin/users/is_admin');
      scenarioOrSurvey.lastModifiedByEmail = scenario.last_modified_by_email ? scenario.last_modified_by_email
        : this.$translate.instant('admin/users/is_admin');
      scenarioOrSurvey.createdOn = scenario.creation_date
        ? scenario.creation_date
        : this.$translate.instant('parameters/scenarios/not_applicable');
      scenarioOrSurvey.lastModifiedOn = scenario.last_modification_date
        ? scenario.last_modification_date
        : this.$translate.instant('parameters/scenarios/not_applicable');
    });
  }

  isLineUrlValid(url) {
    return !!url &&
      !url.endsWith('://') &&
      (
        url.startsWith('https://') ||
        url.startsWith('http://') ||
        url.startsWith('line://') ||
        url.startsWith('tel://')
        //['https://', 'http://', 'line://', 'tel://'].some(word => url.startsWith(word)
      );
  }

  static QuickRepliesFactory($http, $q, MetricsFactory, $translate) {
    return new QuickRepliesService($http, $q, MetricsFactory, $translate);
  }
}

QuickRepliesService.QuickRepliesFactory.$inject = ['$http', '$q', 'MetricsFactory', '$translate'];
